import { ErrorPagesInfo } from "constants/error_pages";
import { PageProps, PageWithLayout } from "@types";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import Head from "next/head";
import { HomeLink } from "./400";

interface Props extends PageProps {}

const ErrorPage404: PageWithLayout<Props> = () => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, follow" />
      </Head>
      <div className="mt-16 w-full">
        <div className=" container-bs">
          <div className=" flex w-full flex-col items-center">
            <div className="mb-6 md:mb-5">
              <img
                src={ErrorPagesInfo[404].image}
                alt="404"
                className="h-[160px] lg:h-[270px] w-auto"
              />
            </div>
            <div>
              <h2 className="headline-sm md:headline-md text-center mb-2.5 text-fds-primary">
                {ErrorPagesInfo[404].title}
              </h2>
              <p className="body-md md:body-lg text-fds-secondary text-center max-w-[296px] md:max-w-[572px]">
                {ErrorPagesInfo[404].subtitle}
              </p>
            </div>
            <div className="mt-6">{HomeLink}</div>
          </div>
        </div>
      </div>
    </>
  );
};

ErrorPage404.getLayout = (page, props) =>
  getDefaultLayout(
    page,
    { ...props },
    {
      footerProps: {
        showAdsFooter: false,
        showAppFooter: false,
        showButtonOrganizationFooter: false,
        showHomeAppFooter: false,
        showLinkFooter: false,
        showMainFooter: false,
        showOrganizationFooter: false,
        showValuesFooter: false,
      },
    }
  );
export default ErrorPage404;
